import { call, takeEvery } from 'redux-saga/effects';

import type { SubscribeAction, SubscribeActionWithArgs } from '../../redux/types';
import type { Args, SubscribeToSignalrProps } from './types';
import type { SagaIterator } from '@redux-saga/types';

import { SIGNALR_DISCONNECTED } from '../../redux/actions/connection';

// ---

type Action = SubscribeAction<string> | SubscribeActionWithArgs<string, Args>;

export type { SubscribeToSignalrProps };
export function* subscribeToHub({
  onSubscribe,
  onUnsubscribe,
  subscribeAction,
  unsubscribeAction,
}: SubscribeToSignalrProps): SagaIterator {
  const triggers = [subscribeAction, unsubscribeAction, SIGNALR_DISCONNECTED];
  const subscribedTopics = new Set<string>();

  yield takeEvery(triggers, function* (action: Action) {
    if (action.type === SIGNALR_DISCONNECTED) {
      return subscribedTopics.clear();
    }

    const args = 'args' in action ? action.args : undefined;
    const topic = action.payload.topic;

    switch (action.type) {
      case subscribeAction:
        if (subscribedTopics.has(topic)) {
          console.warn(`subscribeToSignalr -> this topic (${topic}) is already subscribed)`);
          break;
        }

        subscribedTopics.add(topic);
        yield call(onSubscribe, topic, args);
        break;

      case unsubscribeAction:
        subscribedTopics.delete(topic);
        yield call(onUnsubscribe, topic);
        break;
    }
  });
}
